import React from 'react';

const PaymentHistory = ({ payments }) => {
  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <h2 className="text-2xl font-bold mb-5 flex items-center group">
        <div className="w-10 h-10 rounded-lg bg-accent-yellow/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
          <i className="fas fa-history text-accent-yellow"></i>
        </div>
        Payment History
        <div className="ml-3 text-xs py-1 px-2 bg-accent-yellow/20 rounded-full text-accent-yellow opacity-0 group-hover:opacity-100 transition-medium">
          {payments.length} records
        </div>
      </h2>
      
      <div className="bg-dark-600 rounded-2xl overflow-hidden transform-gpu hover:-translate-y-1 hover:shadow-lg transition-medium">
        {payments.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-dark-500">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider group-hover:text-white transition-medium">Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider group-hover:text-white transition-medium">Description</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider group-hover:text-white transition-medium">Amount</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider group-hover:text-white transition-medium">Status</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider group-hover:text-white transition-medium">Receipt</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-dark-400">
                {payments.map((payment, index) => (
                  <tr 
                    key={index} 
                    className="hover:bg-dark-500 transition-medium transform-gpu hover:scale-[1.01]"
                  >
                    <td className="px-6 py-4 whitespace-nowrap group-hover:text-accent-blue transition-medium">{payment.date}</td>
                    <td className="px-6 py-4 whitespace-nowrap group-hover:text-white transition-medium">{payment.description}</td>
                    <td className="px-6 py-4 whitespace-nowrap group-hover:text-accent-purple transition-medium">{payment.amount}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="px-2 py-1 bg-accent-green bg-opacity-20 text-accent-green rounded-lg text-xs group-hover:scale-105 transition-medium">
                        {payment.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <a 
                        href="#" 
                        className="text-accent-blue hover:underline flex items-center group transition-medium"
                      >
                        <i className="fas fa-download mr-1 group-hover:rotate-360 transition-medium"></i> PDF
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="p-6 text-center text-gray-400 group hover:text-gray-300 transition-medium">
            <i className="fas fa-history text-3xl mb-3 group-hover:text-accent-yellow transition-medium"></i>
            <p>No payment history found</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentHistory;